'use client';

import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

// Dynamically import MemoryMonitor (only loaded client-side)
const MemoryMonitor = dynamic(
    () => import('./MemoryMonitor'),
    { ssr: false }
);

/**
 * ClientDevTools component that only renders development tools in dev mode
 * This helps avoid showing debug components on mobile devices
 */
const ClientDevTools = () => {
    const [isDev, setIsDev] = useState(false);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsDev(process.env.NODE_ENV === 'development');
        setIsMounted(true);
    }, []);

    // Don't render anything during SSR or if not in dev mode
    if (!isMounted || !isDev) return null;

    return <MemoryMonitor position="bottom-right" />;
};

export default ClientDevTools; 